<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
        ></dx-grid>

        <v-dialog persistent v-model="importDialog" max-width="1600">
            <!-- <v-card-title class="headline pl-0 pt-0"
                    >Import Students</v-card-title
                > -->
            <v-stepper v-model="stepper">
                <v-stepper-header>
                    <v-stepper-step :complete="stepper > 1" step="1"
                        >Import</v-stepper-step
                    >

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stepper > 2" step="2"
                        >Preview</v-stepper-step
                    >
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-layout row justify-center class="mb-2">
                            <a @click.stop="downloadSampleFile()" class=""
                                >Sample File</a
                            ></v-layout
                        >
                        <v-layout row justify-center>
                            <v-btn
                                small
                                outline
                                class="mr-2"
                                :loading="uploading"
                                @click="pickFile()"
                            >
                                upload
                                <v-icon right dark>mdi-cloud-upload</v-icon>
                            </v-btn>
                            <div v-if="files.length" class="pt-2 mt-2 ml-2">
                                {{ files[0].name }}
                            </div></v-layout
                        >
                        <input
                            type="file"
                            style="display: none"
                            ref="files"
                            accept=".xlsx, .xls"
                            @change="onFilePicked($event)"
                        />

                        <v-card-actions class="mr-0 mt-3">
                            <v-spacer></v-spacer>
                            <v-btn
                                color="default"
                                dark
                                @click="closeImportDialog()"
                                >Cancel</v-btn
                            >
                            <v-btn
                                :disabled="!files.length"
                                :loading="processing"
                                color="success"
                                @click="importFile(false)"
                            >
                                preview
                            </v-btn>
                        </v-card-actions>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-layout row class="mb-2">
                            <div class="headline ">
                                Preview Results ({{ importResults.length }})
                            </div>
                            <div class="title pt-2 mx-3 text-success">
                                Success: {{ getResults("success") }}
                            </div>
                            <!-- <div class="title pt-2  text-danger">
                                Failed: {{ getResults("failed") }}
                            </div> -->
                            <div class="title pt-2 mx-3 text-warning">
                                Warning: {{ getResults("warning") }}
                            </div>
                        </v-layout>

                        <!-- <data-grid
                            class="accounts-search"
                            url="donors"
                            name="voting-student-match-to-ansl"
                            :columns="importResultsColumns"
                            title="Results"
                            v-bind:hideActions="true"
                        ></data-grid> -->
                        <div style="overflow-y: auto; height: 550px">
                            <vue-good-table
                                v-if="importResults.length"
                                class="schedule-list"
                                styleClass="vgt-table striped"
                                :columns="importResultsColumns"
                                :rows="importResults"
                            >
                                <template slot="table-row" slot-scope="props">
                                    <span
                                        v-if="props.column.isIcon"
                                        class="px-0"
                                    >
                                        <v-icon
                                            class="px-0"
                                            dark
                                            :color="
                                                props.column.iconColor(
                                                    props.row[
                                                        props.column.field
                                                    ],
                                                )
                                            "
                                            >{{
                                                props.column.icon(
                                                    props.row[
                                                        props.column.field
                                                    ],
                                                )
                                            }}</v-icon
                                        >
                                    </span>
                                    <span v-else>
                                        {{
                                            props.formattedRow[
                                                props.column.field
                                            ]
                                        }}
                                    </span>
                                </template>
                            </vue-good-table>
                        </div>

                        <v-card-actions class="mr-0 mt-3">
                            <v-spacer></v-spacer>
                            <v-btn
                                color="default"
                                dark
                                @click="closeImportDialog()"
                                >Cancel</v-btn
                            ><v-btn
                                :loading="processing"
                                color="success"
                                @click="importFile(true)"
                            >
                                save
                            </v-btn>
                        </v-card-actions>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-dialog>

        <v-dialog persistent v-model="exportDialog" max-width="450">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Export Registration Form</v-card-title
                >

                <v-radio-group class="mt-2" v-model="exportMode" row>
                    <v-radio
                        color="success"
                        label="One File"
                        value="onefile"
                    ></v-radio>
                    <v-radio
                        color="success"
                        label="In Separate Files"
                        value="separate"
                    ></v-radio>
                </v-radio-group>

                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="exportDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="exportRegistrationForm()"
                    >
                        export
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="updateDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update Student</v-card-title
                >

                <div class="px-2 mt-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Child First
                        </div>
                        <div>{{ clickedRow.firstH }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Child Last
                        </div>
                        <div>{{ clickedRow.lastH }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Father</div>
                        <div>{{ clickedRow.fatherFirstH }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{
                                clickedRow.address1 +
                                    " " +
                                    (clickedRow.apt ? clickedRow.apt : "")
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Class
                        </div>
                        <div>
                            {{ clickedRow.source + " " + clickedRow.class }}
                        </div>
                    </v-layout>
                    <!--                     <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Father</div>
                        <div class="font-weight-medium caption pa-1 px-2 cyan" style="color: #fff; width: fit-content;">{{ clickedRow.anslID }}</div>
                    </v-layout> -->
                    <div
                        class="font-weight-medium caption pa-1 px-2 cyan mb-2"
                        style="color: #fff; width: fit-content;"
                        v-if="clickedRow.anslID"
                    >
                        ANSL ID: {{ clickedRow.anslID }}
                    </div>
                    <v-divider class="my-2 pb-2"></v-divider>
                    <v-text-field
                        v-model="clickedRow.status"
                        label="Status"
                        hide-details
                        class="mb-4"
                    ></v-text-field>
                    <v-divider class="my-2 pb-2"></v-divider>
                    <div class="font-weight-medium mb-0">
                        Match To ANSL Account
                    </div>
                    <v-btn
                        outline
                        class="text-xs-center"
                        color="success"
                        small
                        @click="searchAnslDialog = true"
                        >Search ANSL Accounts</v-btn
                    >
                    <div v-if="anslAccount.personID">
                        <div class="my-2 font-weight-medium text-success">
                            Selected ANSL Account
                        </div>
                        <div
                            style="border-radius: 4px"
                            class="pa-2 yg-student-account-match"
                        >
                            <div>
                                <div
                                    class="font-weight-medium caption pa-1 px-2 cyan"
                                    style="color: #fff; width: fit-content;"
                                >
                                    {{ anslAccount.personID }}
                                </div>
                                <div class="pt-2">
                                    {{
                                        anslAccount.name +
                                            " - " +
                                            anslAccount.nameH
                                    }}
                                </div>
                            </div>
                            <div>
                                <div class="pb-2">
                                    {{
                                        anslAccount.address1 +
                                            " " +
                                            anslAccount.city +
                                            " " +
                                            anslAccount.zip
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="save"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="statusUpdaterDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2">Update Status</v-card-title>
                <div class="px-2 mt-2">
                    <div style="overflow-y: auto; height: 300px">
                        <div v-for="(student, index) in selected">
                            <div class="font-weight-medium">
                                {{ student.firstH + " " + student.lastH }}
                            </div>
                            <div class="caption">
                                Father: {{ student.fatherFirstH }}
                            </div>
                            <div class="caption">
                                {{
                                    student.address1 +
                                        " " +
                                        (student.apt ? student.apt : "")
                                }}
                            </div>
                            <div class="body-2">
                                {{ student.source + " " + student.class }}
                            </div>
                            <v-divider
                                class="my-2"
                                v-if="index + 1 < selected.length"
                            ></v-divider>
                        </div>
                    </div>
                    <v-text-field
                        v-model="status"
                        label="Status"
                        outline
                        hide-details
                        class="mb-3 mt-2"
                    ></v-text-field>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="statusUpdaterDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveStatus"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import JsZip from "jszip";

export default {
    data: () => ({
        title: "YK Students",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",
        processing: false,
        uploading: false,
        importDialog: false,
        stepper: 0,
        importResults: [],
        searchAnslDialog: false,
        anslAccount: {},
        files: [],
        requestID: "",
        importSource: "",
        sources: [],
        exportMode: "onefile",
        exportDialog: false,

        selected: [],
        statusUpdaterDialog: false,
        updateDialog: false,
        clickedRow: {},
        status: "",

        columns: [
            {
                label: "My Student Num",
                field: "myStudentNum",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Famil yNum",
                field: "familyNum",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "FName",
                field: "fName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "FNameH",
                field: "fNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "LName",
                field: "lName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "LNameH",
                field: "lNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Location",
                field: "location",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Period",
                field: "period",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "Teacher1",
                field: "teacher1",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher2",
                field: "teacher2",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address1",
                field: "address1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Phone",
                field: "phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "FathersCell",
                field: "fathersCell",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "MothersCell",
                field: "mothersCell",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "IsRegistered",
                field: "isRegistered",
                type: "boolean",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        importResultsColumns: [
            {
                label: "Result",
                field: "result",
                format: "",
                width: "300px",
                hidden: false,
                sortable: true,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search..",
                },
            },
            {
                label: "MyStudentNum",
                field: "myStudentNum",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "FamilyNum",
                field: "familyNum",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "FName",
                field: "fName",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "FNameH",
                field: "fNameH",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "LName",
                field: "lName",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "LNameH",
                field: "lNameH",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "Class",
                field: "class",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "Location",
                field: "location",
                hidden: false,
            },
            {
                label: "Period",
                field: "period",
                format: "",
                hidden: false,
                filterType: "",
            },

            {
                label: "Teacher1",
                field: "teacher1",
                hidden: false,
            },
            {
                label: "Teacher2",
                field: "teacher2",
                hidden: false,
            },
            {
                label: "Address1",
                field: "address1",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "Phone",
                field: "phone",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "FathersCell",
                field: "fathersCell",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "MothersCell",
                field: "mothersCell",
                format: "",
                hidden: false,
                filterType: "",
            },
            {
                label: "IsRegistered",
                field: "isRegistered",
                type: "boolean",
                format: "",
                hidden: false,
                filterType: "",
            },
        ],
    }),
    async created() {
        this.loadSources();
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            // this.actions.push({
            //     text: "Update Status",
            //     action: this.openUpdateStatusDialog,
            //     showOnSelection: true,
            // });

            this.actions.push({
                text: "Import Students",
                action: this.openImportDialog,
            });
            // this.actions.push({
            //     text: "Export Registration Form",
            //     name: "ExportRegistrationForm",
            //     action: this.exportRegistrationForm,
            // });

            const exportFormAction = {
                text: "Export Registration Form",
                name: "ExportRegistrationForm",
                loading: false,
                showOnSelection: true,
            };

            exportFormAction.action = () =>
                this.openExportRegistrationForm(exportFormAction.loading);

            //this.actions.push(exportFormAction);

            this.url = "YkStudents";
        },
        async loadSources() {
            this.sources = await this.$http.get("api/ygStudents/getSources");
        },
        openImportDialog() {
            this.importResults = [];
            this.stepper = 1;
            this.importDialog = true;
        },
        pickFile() {
            this.$refs.files.click();
        },
        onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        closeImportDialog() {
            this.importDialog = false;
            this.files = [];
            this.$refs.files.value = "";
        },
        async importFile(saveChanges) {
            try {
                this.processing = true;

                var formData = new FormData();

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/YkStudents/Import?user=" +
                        this.$store.state.authentication.user +
                        "&saveChanges=" +
                        saveChanges,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.processing = false;
                this.importResults = response.results;
                this.stepper = 2;

                if (saveChanges) {
                    this.$notify({
                        group: "notification",
                        text: "Students Saved",
                        type: "success",
                    });
                    this.files = [];
                    this.$refs.files.value = "";
                    this.importDialog = false;
                }

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        getResults(value) {
            if (!this.importResults.length) return 0;

            if (value == "success") {
                return this.importResults.filter(
                    (r) =>
                        r.result == "New Student" ||
                        r.result == "Student Updated",
                ).length;
            }

            if (value == "warning") {
                return this.importResults.filter((r) => r.result.includes("-"))
                    .length;
            }

            return this.importResults.filter(
                (r) =>
                    r.result != "New Student" && r.result != "Student Updated",
            ).length;
        },
        downloadSampleFile() {
            window.location =
                "https://utaw.blob.core.windows.net/files/YKStudentsSample.xlsx";
        },
        openExportRegistrationForm() {
            this.exportDialog = true;
        },
        async exportRegistrationForm() {
            const action = this.actions.find(
                (a) => a.name == "ExportRegistrationForm",
            );

            //const students = this.$refs.grid.grid.getDataSource().items();
            //const students = await this.$refs.grid.loadAll();
            let students = this.$refs.grid.getSelectedRowsData();

            this.processing = true;

            if (this.exportMode == "separate") {
                const zip = new JsZip();

                let i = 0;
                for (const student of students) {
                    await this.export([student], zip);
                }

                zip.generateAsync({ type: "blob" }).then(function(content) {
                    const url = window.URL.createObjectURL(new Blob([content]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "VoterRegistration.zip");
                    document.body.appendChild(link);
                    link.click();
                });
            } else {
                await this.export(students);
            }

            this.processing = false;
            this.exportDialog = false;
        },
        async export(students, zip = null) {
            const response = await this.$http({
                url: "api/ygStudents/downloadVoterRegistrationForm",
                method: "POST",
                data: students,
                responseType: "blob",
            });

            if (zip) {
                const student = students[0];

                const fileName =
                    (student.branch ? student.branch : "") +
                    "_" +
                    (student.class ? student.class : "") +
                    " " +
                    (student.first ? student.first : "") +
                    " " +
                    (student.last ? student.last : "") +
                    ".pdf";
                zip.file(fileName, new Blob([response]));

                return;
            }

            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "VoterRegistration.pdf");
            document.body.appendChild(link);
            link.click();
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        disableExporting() {
            const isAdmin = this.isAdmin();
            return !isAdmin;
        },
        openUpdateStatusDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.statusUpdaterDialog = true;
        },
        async onRowClicked(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));

            this.updateDialog = true;
        },
        onSearchAccountsRowClicked(row) {
            this.searchAnslDialog = false;

            this.anslAccount = row;
        },
        async save() {
            try {
                this.processing = true;

                const data = this.clickedRow;

                if (this.anslAccount && this.anslAccount.personID) {
                    data.anslID = this.anslAccount.personID;
                }

                await this.$http.post("api/YgStudents/Save", [data]);

                this.processing = false;
                this.updateDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveStatus() {
            if (!this.selected.length) {
                return this.$notify({
                    text: "No Students Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.status) {
                return this.$notify({
                    text: "Missing Status",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/YgStudents/Save",
                    this.selected.map((s) => {
                        s.status = this.status;

                        return s;
                    }),
                );

                this.processing = false;
                this.statusUpdaterDialog = false;
                this.status = "";

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.accounts-search.container {
    padding-top: 0px;
}
.yg-student-account-match {
    border: 2px solid #4caf50;
}
</style>
